import clsx from 'clsx'
import {useLayout} from '../../core'
import {Footer} from './Footer'
import {useLocation} from 'react-router-dom'

const FooterWrapper = () => {
  const {config} = useLayout()
  const location = useLocation()
  
  // ซ่อน footer ในหน้า tax-document
  if (location.pathname.includes('/finance/tax-document/')) {
    return null
  }
  
  if (!config.app?.footer?.display) {
    return null
  }

  return (
    <div className='app-footer' id='kt_app_footer'>
      {config.app.footer.containerClass ? (
        <div className={clsx('app-container', config.app.footer.containerClass)}>
          <Footer />
        </div>
      ) : (
        <Footer />
      )}
    </div>
  )
}

export {FooterWrapper}
